import React from 'react'
import { Link } from 'react-router-dom'

const HeaderTopbar = () => {
    return(	
        <div className="topbar">
            <div className="container-fluid">
                <div className="row">
                    <div className="col col-md-7 col-sm-12 col-12">
                        <div className="contact-intro">
                            <ul>
                                <li><i className="fi ti-location-pin"></i> Galle, Sri Lanka</li>
                                <li><i className="fi flaticon-email"></i> info@knowebsolutions.com</li>
                            </ul>
                        </div>
                    </div>
                    <div className="col col-md-5 col-sm-12 col-12">
                        <div className="contact-info">
                            <ul>
                                <li>Visit our social pages</li>
                                <li><a href="https://web.facebook.com/profile.php?id=61563836600897" target="_blank"><i className="ti-facebook"></i></a></li>
                                <li><a href="https://www.linkedin.com/company/knowebsolutions/" target="_blank"><i className="ti-linkedin"></i></a></li>
                                <li><a href="https://www.instagram.com/knowebsolutions" target="_blank"><i className="ti-instagram"></i></a></li>
                                <li><a href="" target="_blank"><i className="fab fa-tiktok"></i></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HeaderTopbar;
